function isEmpty(value: string | null) {
  return value === null || value === '';
};

export function getFilterType(filter: any) {
  if (Array.isArray(filter)) {
    return 'category';
  }

  if (typeof filter == 'number') {
    return 'number';
  }

  if (filter.hasOwnProperty('min') && filter.hasOwnProperty('max')) {
    return 'range';
  }
}

export function formatFilter(filter: any) {
  const filterType = getFilterType(filter);
  if (filterType == 'category') {
    return filter.map((item: FilterOption) => item.id);
  }
  if (filterType == 'number') {
    return `>= ${filter}`;
  }
  if (filter.hasOwnProperty('min') && filter.hasOwnProperty('max')) {
    const query = [];
    if (!isEmpty(filter.min)) {
      query.push(`>= ${filter.min}`);
    }
    if (!isEmpty(filter.max)) {
      query.push(`< ${filter.max}`);
    }

    let value;
    if (query.length === 0) {
      value = null
    } else {
      value = query.length === 1 ? query : ["and", ...query]
    }

    return value;
  }
}

export function formatFilters(filterValues: any) {
  const queryFilters = {};
  for (const key in filterValues) {
    if (filterValues[key] !== null) {
      queryFilters[key] = formatFilter(filterValues[key]);
    }
  }

  return queryFilters;
}

